<!-- Create template variable of all resolved observables -->
<ng-container
	*ngIf="{
		isOnline: isOnline$ | async,
		isSyncing: isSyncing$ | async,
		hasFailedRequests: hasFailedRequests$ | async
	} as obs"
>
	<ion-button
		(click)="manualSync()"
		class="manual-sync-btn"
		[class.spin]="obs.isSyncing"
		auto-hide="false"
	>
		<ion-icon
			class="sync-icon"
			[class.offline]="!obs.isOnline || obs.hasFailedRequests"
			slot="icon-only"
			name="sync-outline"
		></ion-icon>
	</ion-button>
	<div *ngIf="lastSyncTime" id="lastSync">
		Last sync: {{this.lastSyncTime}}
	</div>
</ng-container>
